module.exports = __webpack_public_path__ + "img/them-10.b33f88bf.png";